var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Detalle de Autorización" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  attrs: { disabled: _vm.observar },
                  on: {
                    click: function($event) {
                      return _vm.guardar()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Detalle" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.tipooperacion.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.tipooperacion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipooperacion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipooperacion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.numOperacion.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.numOperacion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.numOperacion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.numOperacion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ajustar-texto",
                                        staticStyle: {
                                          cursor: "pointer",
                                          "margin-top": "4%"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.prueba()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "ajustar-texto",
                                            staticStyle: {
                                              display: "inline-block",
                                              color: "rgb(39, 72, 142)"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        Descargar Informe\n                      "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons ajustar",
                                            staticStyle: {
                                              color: "rgb(39, 72, 142)",
                                              width: "10%",
                                              "margin-left": "10%",
                                              display: "inline-block",
                                              cursor: "pointer"
                                            },
                                            attrs: {
                                              id: "5544",
                                              title: "Descargar informe"
                                            }
                                          },
                                          [_vm._v("file_download_outlined")]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.fechaSolicitud.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.fechaSolicitud.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.fechaSolicitud,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.fechaSolicitud.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.nombreUsuario.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.nombreUsuario.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombreUsuario,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.nombreUsuario.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.observacion.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.observacion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.observacion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.observacion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.fechaRevision.label,
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.fechaRevision.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.fechaRevision,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.fechaRevision.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.estado.label,
                                        items: _vm.estadoList,
                                        "item-text": "text",
                                        "item-value": "value",
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.estado.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.estado,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.estado.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label:
                                          _vm.formFields.estado_autorizador
                                            .label,
                                        items: _vm.estadoList,
                                        "item-text": "text",
                                        "item-value": "value",
                                        disabled: _vm.observar,
                                        clearable: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.estado_autorizador
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.estado_autorizador,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.estado_autorizador.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.comentario.label,
                                        disabled: _vm.observar
                                      },
                                      model: {
                                        value: _vm.formFields.comentario.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.comentario,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.comentario.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }